import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import qs from 'qs'
import * as R from 'ramda'

import PATHS from 'utils/paths'

import { QUIZ_DIAGNOSTICS_PARAMS } from '../utils/quizDiagnosticsParams'

export const useSelectQuizDiagnosticsChapter = () => {
  const {
    replace,
    location: { search }
  } = useHistory()

  const selectChapter = useCallback(
    (chapterId: string) => {
      if (!chapterId) {
        return
      }

      const parsedQuery = qs.parse(search, { ignoreQueryPrefix: true })
      const newQuery = {
        ...R.dissoc(QUIZ_DIAGNOSTICS_PARAMS.chapterId, parsedQuery),
        [QUIZ_DIAGNOSTICS_PARAMS.chapterId]: chapterId
      }

      replace(
        `${PATHS.sectionAverages}?${qs.stringify(newQuery, { encode: false })}`
      )
    },
    [replace, search]
  )

  const selectAllChapters = useCallback(() => {
    const parsedQuery = qs.parse(search, { ignoreQueryPrefix: true })
    const newQuery = R.dissoc(QUIZ_DIAGNOSTICS_PARAMS.chapterId, parsedQuery)
    const queryString = qs.stringify(newQuery, { encode: false })

    replace(
      queryString
        ? `${PATHS.chapterAverages}?${queryString}`
        : PATHS.chapterAverages
    )
  }, [replace, search])

  return { selectChapter, selectAllChapters }
}
